<div class="w-full min-h-screen bg-white p-3 md:p-5">
  <p-toast></p-toast>

  <div class="orders-page-header mb-4">
    <div class="orders-page-title">
      <h2 class="text-2xl font-bold m-0 text-900">Ventas Manuales Activas</h2>
      <p class="text-500 m-0 text-sm mt-1">Gestiona las ventas realizadas por WhatsApp o tienda física.</p>
    </div>
    <div class="orders-kpi-group">
      <div class="orders-kpi-card surface-100 p-3 border-round border-1 border-200 flex align-items-center gap-2">
        <i class="pi pi-wallet text-2xl text-blue-500"></i>
        <div>
          <span class="text-500 text-xs font-bold uppercase block">Total Adelantado</span>
          <span class="text-lg font-bold text-900">{{ totalAdelantado | currency:'PEN':'symbol' }}</span>
        </div>
      </div>
      <div class="orders-kpi-card surface-100 p-3 border-round border-1 border-200 flex align-items-center gap-2">
        <i class="pi pi-truck text-2xl text-cyan-600"></i>
        <div>
          <span class="text-500 text-xs font-bold uppercase block">TOTAL ENVÍO ADELANTADO</span>
          <span class="text-lg font-bold text-cyan-700">{{ totalEnvioInformativo | currency:'PEN':'symbol' }}</span>
        </div>
      </div>
      <div class="orders-kpi-card surface-100 p-3 border-round border-1 border-200 flex align-items-center gap-2">
        <i class="pi pi-clock text-2xl text-orange-500"></i>
        <div>
          <span class="text-500 text-xs font-bold uppercase block">Total Pago Pendiente</span>
          <span class="text-lg font-bold text-orange-600">{{ totalPagoPendiente | currency:'PEN':'symbol' }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="flex flex-column gap-4 mb-4">
    <div class="grid align-items-end orders-list-filters">
      <div class="orders-filter-cols-4 col-12 sm:col-6 lg:col-6 field m-0 mb-2 sm:mb-0">
        <label class="text-xs font-semibold text-600 block mb-1">Tipo de envío</label>
        <p-select
          [options]="tipoEnvioFilterOptions"
          [(ngModel)]="tipoEnvioFilterId"
          (onChange)="reloadFirst()"
          optionLabel="label"
          optionValue="value"
          placeholder="Tipo de envío"
          styleClass="border-round-lg w-full"
          appendTo="body">
        </p-select>
      </div>
      <div class="orders-filter-cols-4 col-12 sm:col-6 lg:col-6 field m-0 mb-2 sm:mb-0">
        <label class="text-xs font-semibold text-600 block mb-1">Estado</label>
        <p-multiSelect [options]="estadoOptions" [(ngModel)]="estadoFilterIds" (onChange)="reloadFirst()"
          optionLabel="nombreEstado" optionValue="id" placeholder="Estado" styleClass="border-round-lg w-full"
          appendTo="body" [showClear]="true"></p-multiSelect>
      </div>
      <div class="orders-filter-cols-4 col-12 sm:col-6 lg:col-6 field m-0 mb-2 sm:mb-0">
        <label class="text-xs font-semibold text-600 block mb-1">Fecha registro</label>
        <p-datepicker [(ngModel)]="fechaRegistroFilter" (ngModelChange)="onFechaRegistroChange()" dateFormat="dd/mm/yy"
          [showIcon]="true" appendTo="body" styleClass="border-round-lg w-full" placeholder="Fecha" [showClear]="true"></p-datepicker>
      </div>
      <div class="orders-filter-cols-4 col-12 sm:col-6 lg:col-6 field m-0 mb-2 sm:mb-0">
        <label class="text-xs font-semibold text-600 block mb-1">Fecha entrega</label>
        <p-datepicker [(ngModel)]="fechaEntregaFilter" (ngModelChange)="reloadFirst()" dateFormat="dd/mm/yy"
          [showIcon]="true" appendTo="body" styleClass="border-round-lg w-full" placeholder="Fecha" [showClear]="true"></p-datepicker>
      </div>
      <div class="orders-filter-row2-origen col-12 sm:col-6 md:col-3 lg:col-3 field m-0 mb-2 sm:mb-0">
        <label class="text-xs font-semibold text-600 block mb-1">Origen de venta</label>
        <p-select
          [options]="origenVentaFilterOptions"
          [(ngModel)]="origenVentaFilterId"
          (onChange)="reloadFirst()"
          optionLabel="label"
          optionValue="value"
          placeholder="Origen de venta"
          styleClass="border-round-lg w-full"
          appendTo="body">
        </p-select>
      </div>
      <div class="orders-filter-row2-cliente col-12 sm:col-6 md:col-4 lg:col-4 field m-0 mb-2 sm:mb-0">
        <label class="text-xs font-semibold text-600 block mb-1">Cliente</label>
        <input pInputText [(ngModel)]="clienteFilter" (input)="scheduleServerLoad()" placeholder="Nombre o teléfono"
          class="border-round-lg w-full max-w-full" />
      </div>
      <div class="orders-filter-row2-id col-12 sm:col-6 md:col-2 lg:col-2 field m-0 mb-2 sm:mb-0">
        <label class="text-xs font-semibold text-600 block mb-1">Buscar por ID</label>
        <input pInputText [(ngModel)]="idSearch" (input)="scheduleServerLoad()" placeholder="Buscar por ID..."
          class="border-round-lg w-full max-w-full" />
      </div>
      <div class="orders-filter-export-actions col-12 sm:col-6 md:col-3 lg:col-3 field m-0 mb-2 sm:mb-0 flex align-items-end justify-content-start sm:justify-content-end gap-2 flex-wrap">
        <button pButton icon="pi pi-file-excel" label="Excel" type="button"
          class="p-button-outlined p-button-success border-round-3xl flex-shrink-0"
          (click)="exportExcel()" [loading]="exporting === 'excel'"
          [disabled]="exporting !== null || totalRecords === 0"></button>
        <button pButton icon="pi pi-file-pdf" label="PDF" type="button"
          class="p-button-outlined p-button-danger border-round-3xl flex-shrink-0"
          (click)="exportPdf()" [loading]="exporting === 'pdf'"
          [disabled]="exporting !== null || totalRecords === 0"></button>
      </div>
    </div>
    <div class="flex gap-2 align-items-end flex-wrap surface-50 border-round-lg p-3 border-1 border-200">
      <div class="field m-0">
        <label class="text-xs font-semibold text-600 block mb-1">Hoja de empaque</label>
        <p-select [options]="packingPerPageOptions" [(ngModel)]="packingPerPage"
          optionLabel="label" optionValue="value" appendTo="body"
          styleClass="border-round-lg" [style]="{'min-width':'140px'}"></p-select>
      </div>
      <div class="field m-0">
        <label class="text-xs font-semibold text-600 block mb-1">Estado impresión</label>
        <p-select [options]="packingStatusOptions" [(ngModel)]="packingPrintFilter"
          (onChange)="reloadFirst()" optionLabel="label" optionValue="value" appendTo="body"
          styleClass="border-round-lg" [style]="{'min-width':'150px'}"></p-select>
      </div>
      <button pButton type="button" icon="pi pi-print" label="Imprimir seleccionados"
        class="p-button-outlined border-round-lg"
        (click)="printSelected()" [disabled]="!selectedOrders.length"></button>
      <button pButton type="button" icon="pi pi-clone" label="Últimos 3"
        class="p-button-outlined p-button-secondary border-round-lg"
        (click)="printLastThree()" [disabled]="filteredOrders.length === 0"></button>
    </div>
    <div class="flex gap-3 align-items-center flex-wrap" *ngIf="selectedOrders.length">
      <span class="text-sm text-600">{{ selectedOrders.length }} pedido(s) seleccionado(s)</span>
      <button pButton label="Aplicar estado a seleccionados" icon="pi pi-check-square" class="p-button-outlined border-round-lg"
        (click)="openBulkStatusDialog()"></button>
    </div>
  </div>

  <p-table #dt
           [value]="filteredOrders"
           [lazy]="true"
           (onLazyLoad)="loadOrders($event)"
           [first]="first"
           [rows]="rows"
           [totalRecords]="totalRecords"
           [paginator]="true"
           [rowsPerPageOptions]="[10, 25, 50]"
           [loading]="loading"
           styleClass="p-datatable-sm"
           responsiveLayout="scroll"
           dataKey="id"
           [(selection)]="selectedOrders"
           [selectionMode]="'multiple'">

    <ng-template pTemplate="header">
      <tr>
        <th style="width: 40px">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th style="width: 8%">ID</th>
        <th style="width: 12%">Fecha registro</th>
        <th style="width: 12%">Fecha de entrega</th>
        <th style="width: 18%">Cliente</th>
        <th style="width: 14%">Destino / Punto</th>
        <th style="width: 12%">Tipo envío</th>
        <th style="width: 10%">Pago</th>
        <th style="width: 10%">Total</th>
        <th style="width: 14%" class="text-center">Acciones</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-order>
      <tr class="transition-colors hover:surface-50">
        <td>
          <p-tableCheckbox [value]="order"></p-tableCheckbox>
        </td>
        <td class="font-bold text-900">#{{ order.id }}</td>
        <td class="text-sm text-600">{{ order.createdAt | peruDate:'dd/MM/yyyy HH:mm' }}</td>
        <td>
          <div class="flex flex-column">
            <span class="font-medium text-800">{{ order.scheduledDate | peruDate:'dd/MM/yyyy' }}</span>
            <span class="text-xs text-500">{{ order.scheduledTime }}</span>
          </div>
        </td>
        <td>
          <div class="flex flex-column">
            <span class="font-bold text-900 text-sm">{{ order.clientName }}</span>
            <span class="text-xs text-500 flex align-items-center gap-1">
              <i class="pi pi-whatsapp text-green-500" style="font-size: 0.7rem"></i> {{ order.clientPhone }}
            </span>
          </div>
        </td>
        <td>
          <div class="flex flex-column">
            <span class="font-bold text-sm text-900">{{ order.district || order.deliveryAddress || '—' }}</span>
            <span class="text-xs text-600" *ngIf="order.deliveryAddress && order.district">{{ order.deliveryAddress }}</span>
            <div class="flex flex-wrap gap-1 mt-1" *ngIf="order.estados?.length">
              <span *ngFor="let e of order.estados" class="text-xs font-bold px-2 py-1 border-round border-1 border-300" [style.background-color]="e.color || '#e5e7eb'" [style.color]="e.color ? '#fff' : '#4b5563'">{{ e.nombreEstado }}</span>
            </div>
            <p-tag *ngIf="!order.estados?.length" [value]="order.status" [severity]="getSeverity(order.status)" [rounded]="true" styleClass="mt-1 w-max"></p-tag>
          </div>
        </td>
        <td>
          <p-tag [value]="order.tipoEnvio?.nombreTipoEnvio || order.deliveryMethod || '—'" severity="info" [rounded]="true"></p-tag>
        </td>
        <td>
          <div class="flex flex-column gap-1">
            <p-tag [value]="getPaymentTagLabel(order.paymentStatus, order)"
                   [severity]="getPaymentTagSeverity(order.paymentStatus, order)"
                   [rounded]="true" styleClass="w-max"></p-tag>
            <span *ngIf="getOrderPendientePagar(order) > 0" class="text-xs text-red-500 font-bold">
              Debe: {{ getOrderPendientePagar(order) | currency:'PEN':'symbol' }}
            </span>
            <span *ngIf="getOrderAmountPaid(order) > 0" class="text-xs text-600 block">
              Adel.: {{ getOrderAmountPaid(order) | currency:'PEN':'symbol' }}
            </span>
          </div>
        </td>
        <td class="font-bold text-900 text-base">
          {{ order.totalAmount | currency:'PEN':'symbol' }}
        </td>
        <td class="text-center">
          <div class="flex justify-content-center gap-2 flex-wrap">
            <button pButton icon="pi pi-print" class="p-button-text p-button-rounded p-button-secondary text-600"
                    (click)="printOne(order)" pTooltip="Imprimir hoja de empaque"></button>
            <button pButton icon="pi pi-eye" class="p-button-text p-button-rounded p-button-secondary text-600"
                    (click)="openViewDialog(order)" pTooltip="Ver"></button>
            <button pButton icon="pi pi-check-square" class="p-button-text p-button-rounded p-button-secondary text-600"
                    (click)="openStatusDialog(order)" pTooltip="Estados"></button>
            <button pButton icon="pi pi-pencil" class="p-button-text p-button-rounded p-button-secondary text-600"
                    (click)="editOrder(order.id)" pTooltip="Editar"></button>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr><td colspan="10" class="text-center p-4">No hay pedidos activos con el filtro seleccionado.</td></tr>
    </ng-template>
  </p-table>
</div>

<p-dialog [header]="isBulkStatus ? 'Actualizar Estado (varios pedidos)' : 'Actualizar Estado'" [(visible)]="statusDialogVisible" [modal]="true"
          [breakpoints]="{'960px': '75vw', '640px': '90vw'}" [style]="{width: '380px'}"
          [draggable]="false" [resizable]="false" styleClass="p-fluid">
  <div class="flex flex-column gap-3 pt-2">
    <div class="text-center p-3 border-round-xl bg-gray-50 border-1 border-gray-100" *ngIf="selectedOrderForStatus">
      <span class="font-bold block text-2xl text-900 mb-1">#{{selectedOrderForStatus.id}}</span>
      <span class="text-sm text-600">{{selectedOrderForStatus.clientName}}</span>
    </div>
    <div class="text-center p-3 border-round-xl bg-gray-50 border-1 border-gray-100" *ngIf="isBulkStatus && selectedOrders.length">
      <span class="font-bold block text-2xl text-900 mb-1">{{ selectedOrders.length }} pedido(s)</span>
      <span class="text-sm text-600">Aplicar estados a los pedidos seleccionados</span>
    </div>
    <div class="field">
      <label class="font-bold mb-2 block text-sm text-700">Estados (selección múltiple)</label>
      <p-multiSelect [options]="estadoOptions" [(ngModel)]="selectedEstadoIds" optionLabel="nombreEstado" optionValue="id"
        placeholder="Seleccionar estados" styleClass="w-full border-round-lg" appendTo="body"
        [filter]="true" filterPlaceHolder="Buscar..."></p-multiSelect>
    </div>
    <p class="text-xs text-500 m-0">Una venta puede tener más de un estado asignado.</p>
  </div>
  <ng-template pTemplate="footer">
    <div class="flex gap-2 justify-content-end">
      <button pButton label="Cancelar" class="p-button-text text-600" (click)="statusDialogVisible=false; isBulkStatus=false"></button>
      <button pButton label="Confirmar" class="p-button-black border-round-lg" (click)="saveStatus()"></button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog header="Resumen del Pedido" [(visible)]="viewDialogVisible" [modal]="true"
          [breakpoints]="{'960px': '95vw', '640px': '100vw'}" [style]="{width: '500px'}"
          [draggable]="false" [resizable]="false" styleClass="p-fluid">
  <div *ngIf="selectedOrderForView" class="p-1">
    <div class="flex justify-content-between align-items-start mb-4 border-bottom-1 border-gray-100 pb-3">
      <div>
        <span class="text-2xl font-bold block text-900">Pedido #{{selectedOrderForView.id}}</span>
        <span class="text-sm text-500 mt-1 block">
          <i class="pi pi-clock text-xs mr-1"></i>
          {{selectedOrderForView.scheduledDate | peruDate:'dd MMM yyyy'}} • {{selectedOrderForView.scheduledTime}}
        </span>
      </div>
      <div class="flex flex-wrap gap-1" *ngIf="selectedOrderForView.estados?.length">
        <span *ngFor="let e of selectedOrderForView.estados" class="text-xs font-bold px-2 py-1 border-round border-1 border-300" [style.background-color]="e.color || '#e5e7eb'" [style.color]="e.color ? '#fff' : '#4b5563'">{{ e.nombreEstado }}</span>
      </div>
      <p-tag *ngIf="!selectedOrderForView.estados?.length" [value]="selectedOrderForView.status" [severity]="getSeverity(selectedOrderForView.status)" [rounded]="true"></p-tag>
    </div>

    <div class="grid">
      <div class="col-6">
        <div class="text-xs font-bold text-500 uppercase mb-1">Cliente</div>
        <div class="flex align-items-start gap-1 w-full">
          <span class="min-w-0" style="width: fit-content; max-width: calc(100% - 2.75rem); word-break: break-word; overflow-wrap: anywhere;">{{selectedOrderForView.clientName}}</span>
          <button type="button" pButton icon="pi pi-copy" class="p-button-text p-button-rounded p-button-sm flex-shrink-0 align-self-start w-2rem h-2rem" pTooltip="Copiar nombre" (click)="copyToClipboard(selectedOrderForView.clientName || '')"></button>
        </div>
        <div class="text-sm text-600 mt-1 flex align-items-center gap-1 w-full">
          <span class="min-w-0 inline-flex align-items-center gap-1" style="width: fit-content; max-width: calc(100% - 2.75rem);"><i class="pi pi-whatsapp flex-shrink-0 text-green-500"></i>{{selectedOrderForView.clientPhone}}</span>
          <button type="button" pButton icon="pi pi-copy" class="p-button-text p-button-rounded p-button-sm flex-shrink-0 w-2rem h-2rem" pTooltip="Copiar número" (click)="copyToClipboard(selectedOrderForView.clientPhone || '')"></button>
        </div>

        <div class="mt-2" *ngIf="selectedOrderForView.saleOrigin">
            <span class="bg-blue-50 text-blue-700 border-1 border-blue-200 px-2 py-1 border-round text-xs font-bold flex align-items-center w-max">
                <i class="pi pi-shopping-bag mr-1 text-xs"></i> {{selectedOrderForView.saleOrigin}}
            </span>
        </div>
      </div>
      <div class="col-6">
        <div class="text-xs font-bold text-500 uppercase mb-1">Entrega</div>
        <div class="font-medium text-900">{{ selectedOrderForView.tipoEnvio?.nombreTipoEnvio || selectedOrderForView.deliveryMethod }}</div>
        <div class="text-sm text-600 mt-1 flex align-items-start gap-1 w-full" *ngIf="selectedOrderForView.deliveryAddress">
          <span class="min-w-0" style="width: fit-content; max-width: calc(100% - 2.75rem); word-break: break-word; overflow-wrap: anywhere;">{{selectedOrderForView.deliveryAddress}}</span>
          <button type="button" pButton icon="pi pi-copy" class="p-button-text p-button-rounded p-button-sm flex-shrink-0 align-self-start w-2rem h-2rem" pTooltip="Copiar dirección" (click)="copyToClipboard(getFullAddress(selectedOrderForView))"></button>
        </div>
        <div class="text-sm text-500 flex align-items-center gap-1" *ngIf="selectedOrderForView.distrito?.nombre || selectedOrderForView.district">
          <span>{{ selectedOrderForView.distrito?.nombre || selectedOrderForView.district }}</span>
          <button type="button" *ngIf="!selectedOrderForView.deliveryAddress" pButton icon="pi pi-copy" class="p-button-text p-button-rounded p-button-sm" pTooltip="Copiar" (click)="copyToClipboard(getFullAddress(selectedOrderForView))"></button>
        </div>
        <div class="flex flex-wrap gap-1 mt-2" *ngIf="selectedOrderForView.estados?.length">
          <span *ngFor="let e of selectedOrderForView.estados" class="text-xs font-bold px-2 py-1 border-round border-1 border-300" [style.background-color]="e.color || '#e5e7eb'" [style.color]="e.color ? '#fff' : '#4b5563'">{{ e.nombreEstado }}</span>
        </div>
      </div>

      <div class="col-12 mt-2" *ngIf="selectedOrderForView.notes">
        <div class="bg-yellow-50 p-3 border-round border-1 border-yellow-100 text-sm text-yellow-900">
          <span class="font-bold block mb-1">Nota:</span>
          "{{selectedOrderForView.notes}}"
        </div>
      </div>
    </div>

    <div class="font-bold mb-2">Productos</div>

    <div class="flex flex-column gap-2">
      <div *ngFor="let item of selectedOrderForView.items" class="flex align-items-center gap-3 p-3 border-round border-1 border-gray-200 bg-gray-50">

        <div class="flex-1">
          <div class="font-bold text-900 text-base mb-1">
            {{ item.product?.name || item.product?.productName || item.productName || 'Producto sin nombre' }}
          </div>

          <div class="flex flex-wrap gap-2 text-sm text-700">
            <span class="bg-white border-1 border-gray-300 px-2 border-round text-xs font-bold py-1">
              Talla: {{item.size}}
            </span>

            <span *ngIf="item.color" class="bg-white border-1 border-gray-300 px-2 border-round text-xs font-bold py-1 flex align-items-center gap-1">
              <div class="w-1rem h-1rem border-circle border-1 border-gray-400" [style.background-color]="item.color"></div>
              {{item.color}}
            </span>

            <span class="font-bold text-900 ml-1 flex align-items-center">{{ item.quantity }} und.</span>
          </div>
        </div>

        <div class="font-bold text-900 text-lg">
          {{ (item.subTotal > 0 ? item.subTotal : ((item.unitPrice || item.product?.price || 0) * item.quantity)) | currency:'PEN':'symbol' }}
        </div>
      </div>
    </div>

    <div class="divider my-3 border-top-1 border-gray-200"></div>

    <div class="flex flex-column gap-2" *ngIf="selectedOrderForView as order">

      <div class="flex justify-content-between text-sm text-600">
        <span>Subtotal Prendas</span>
        <span class="font-bold text-900">{{ calculateItemsSubtotal(order) | currency:'PEN':'symbol' }}</span>
      </div>

      <div *ngIf="(order?.discountAmount ?? 0) > 0" class="flex justify-content-between text-sm text-red-500 font-bold">
        <span>Descuento</span>
        <span>- {{ order.discountAmount | currency:'PEN':'symbol' }}</span>
      </div>

      <div class="flex justify-content-between text-sm text-500 italic">
        <span>Envío (informativo)</span>
        <span>{{ (order.deliveryPrice ?? 0) | currency:'PEN':'symbol' }}</span>
      </div>

      <div class="flex justify-content-between text-sm mb-1">
        <span>Adelanto / Pagado</span>
        <span class="font-medium text-900">{{ getOrderAmountPaid(order) | currency:'PEN':'symbol' }}</span>
      </div>
      <div class="flex justify-content-between text-sm mb-1" *ngIf="getOrderPendientePagar(order) > 0">
        <span>Pendiente de pagar</span>
        <span class="font-bold text-orange-600">{{ getOrderPendientePagar(order) | currency:'PEN':'symbol' }}</span>
      </div>

      <div class="flex justify-content-between align-items-center mt-2 pt-2 border-top-1 border-gray-100">
        <span class="text-lg font-bold text-900">Total Final</span>
        <span class="text-xl font-bold text-900">{{ order.totalAmount | currency:'PEN':'symbol' }}</span>
      </div>
    </div>
    </div>

  <ng-template pTemplate="footer">
    <button pButton label="Cerrar" class="p-button-text text-600 w-full" (click)="viewDialogVisible=false"></button>
  </ng-template>
</p-dialog>
